/**
 * SKU 相关 API
 */

import api from './client';
import type { SKU, Period, Keyword, CompetitorASIN, TrendData } from '../../types';

export const skuAPI = {
    list: () => api.get<SKU[]>('/skus/'),
    get: (id: number) => api.get<SKU>(`/skus/${id}/`),
    getById: async (id: number) => {
        const response = await api.get<SKU>(`/skus/${id}/`);
        return response.data;
    },
    create: (data: Partial<SKU>) => api.post<SKU>('/skus/', data),
    update: async (id: number, data: Partial<SKU>) => {
        const response = await api.patch<SKU>(`/skus/${id}/`, data);
        return response.data;
    },
    delete: (id: number) => api.delete(`/skus/${id}/`),
    getPeriods: (id: number) => api.get<Period[]>(`/skus/${id}/periods/`),
    getKeywords: (id: number, periodId?: number) => {
        const params = periodId ? { period_id: periodId } : {};
        return api.get<Keyword[]>(`/skus/${id}/keywords/`, { params });
    },
    getTrends: (id: number, metric: string, periods?: string) => {
        const params: any = { metric };
        if (periods) params.periods = periods;
        return api.get<{ metric: string; data: TrendData[] }>(`/skus/${id}/trends/`, { params });
    },
    getCompetitors: (id: number) => api.get<CompetitorASIN[]>(`/skus/${id}/competitors/`),
    getSummary: (id: number) => api.get(`/skus/${id}/summary/`),
    generateSellingPointFABE: async (id: number, sellingPoint: string, index: number) => {
        const response = await api.post(`/skus/${id}/generate_selling_point_fabe/`, {
            selling_point: sellingPoint,
            index
        });
        return response.data;
    },
};
